<script setup lang="ts">
const { state: myself } = useSelf()
const { cacheState } = useCache()

const displayName = ref("")
const accountHandle = computed(() => myself.value.user?.handle()?.handle)
</script>

<template>
  <collection-scroll-container vertical>
    <div class="settings-view-main">
      <div class="section-title">
        Account
      </div>
      <div class="user-details">
        <user-avatar
          :user="myself.user"
          class="user-avatar"
          :size="64"
        />
        <div class="display-name">
          <div class="title">
            Display Name
          </div>
          <div class="value">
            <interface-input disabled v-model="displayName" placeholder="Enter a display name" />
          </div>
        </div>
        <div class="account-handle">
          <div class="title">
            Account Handle
          </div>
          <div class="value">
            <interface-input
              :model-value="accountHandle"
              disabled
              placeholder="Enter a display name"
            />
          </div>
        </div>
      </div>
      <hr class="divider">
      <div class="settings-item">
        <div class="title">
          Email Address
        </div>
        <div class="value">
          <div class="description">
            {{ myself.user?.email() }}
          </div>
          <div class="settings-button">
            Change email
          </div>
        </div>
      </div>
      <div class="settings-item">
        <div class="title">
          Password
        </div>
        <div class="value">
          <div class="description">
            Set new password
          </div>
          <div class="settings-button">
            Change password
          </div>
        </div>
      </div>
      <hr class="divider">
      <!-- FIXME add some application-level settings, e.g. "clear cache and refresh" -->
      <!-- <div class="section-title">
        Application
      </div> -->
    </div>
  </collection-scroll-container>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.nav-spacer
  @apply pointer-events-none w-full flex-none

.settings-view-main
  @apply p-4 max-w-screen-md mx-auto
  @apply flex flex-col gap-4

.section-title
  @apply t-settings-title mt-[#{$nav-h-default}]

.user-details
  @apply flex gap-4 items-center
.user-avatar
  @apply flex-none w-16 h-16

.display-name, .account-handle
  @apply flex flex-col gap-2.5 w-full
  .title
    @apply t-settings-item

.divider
  @apply border-$page-b-divider border-0.5 my-2

.settings-button
  @apply cursor-not-allowed // FIXME
  @apply flex items-center gap-1
  @apply rounded-[#{$menu-br-item}] p-1 px-1.5 -m-1 -mx-1.5 h-7
  @apply t-settings-description text-[#{$global-t-default}]
  @apply bg-[#{$page-settings-select-bg-select}]
  @apply outline outline-0.5 outline-[#{$page-settings-select-b-select}]

.settings-item
  .title
    @apply t-settings-item
  .value
    @apply flex justify-between items-center
  .description
    @apply t-settings-description text-[#{$global-t-secondary}]

</style>
